import { StoryblokServerComponent } from '@storyblok/react/rsc';
import PricingCardsClient from '@/components/PricingCardsClient';

/**
 * Server wrapper for the pricing table. The plan cards' dynamic "Content area"
 * (body) holds nested bloks, which are server components — so they're rendered
 * here and handed to the client component (which owns the monthly/yearly toggle)
 * as ready-made elements, keyed by card uid.
 */
const PricingCards = ({ blok }) => {
  const cardBodies = {};
  for (const card of blok.cards || []) {
    cardBodies[card._uid] = (card.body || []).map((b) => (
      <StoryblokServerComponent blok={b} key={b._uid} />
    ));
  }

  return <PricingCardsClient blok={blok} cardBodies={cardBodies} />;
};

export default PricingCards;
